module.exports = __webpack_public_path__ + "img/07.3a2054bc.png";